import { render } from "./MailInboxPagination.vue?vue&type=template&id=24141b9c"
import script from "./MailInboxPagination.vue?vue&type=script&lang=js"
export * from "./MailInboxPagination.vue?vue&type=script&lang=js"

import "../styles/mail-inbox-pagination.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__